import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Footer from './Footer'
import Header from './Header'

import '../sass/index.scss'
import '../theme/global-styles'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content:
                'Contribute to the achievement of social and economic equity in collaboration with people with disabilities through an inclusive approach',
            },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <a href="#main" className="sr-only">
          Skip to content
        </a>
        <Header siteTitle={data.site.siteMetadata.title} />
        <main id="main">{children}</main>
        <Footer />
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
